import { defineStore } from 'pinia'
import type { BankListItem } from '~composables/deposit/interface'

interface BanksState {
  banks: BankListItem[]
}
const STORE_NAME = 'supportedBanks'

export const useSupportedBanksStore = defineStore(STORE_NAME, {
  state: (): BanksState => ({
    banks: []
  }),
  persist: false,
  actions: {
    addBank(bank: BankListItem) {
      this.banks.push(bank)
    },
    removeBank(index: number) {
      this.banks.splice(index, 1)
    },
    setBanks(banks: BankListItem[]) {
      this.banks = banks
    }
  }
})
